export default "__VITE_ASSET__DNx6uQt1__"